import MerchantMenuImportSuccessPage from '../../../components/merchant/inventory/import-success/MerchantMenuImportSuccessPage'

export default function MenuImportSuccess() {
  return <MerchantMenuImportSuccessPage />
}
